
export interface IAppConfig {
  ApiUrl: string;
  WebUrl: string;
  ViewUrl: string;
  PdfUrl: string;
  PublicKey: string[];
  LocalKey: string;
  DigitalIdSdkJsUrl: string;
  DigitalIdClientId: string;
}

export class CurrentUser {
  UserId: string;
  Email: string;
  UserName: string;
  Name: string;
  Fname: string;
  UserTypeId: string;
  Role: string;
  AgentId: string;
  ClientId: string;
  EnquiryId: string;
  IsPartOfTeam: string;
  TeamId: string;
  TeamName: string;
  IsLeader: string;
  YourCode: string;
}

export class ScreenSize {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  small: boolean;
}

export class DeviceInfo {
  os: string;
  osVersion: string;
  browser: string;
  browserVersion: string;
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export class UserAuthModel {
  email: string;
  userName: string;
  password: string;
  confirmPassword: string;
  tfn: string;
  dob: Date;
  firstName: string;
  lastName: string;
  mobile: string;
  code: string;
  oldPassword: string;
  mix: string;
  ip: string;
  sid: string;
  fromFbLead: string;
  regIp: string;
  referralCode: string;
}

export class LoginResponse {
  success: boolean;
  error: string;
  uid: string;
  isPartOfTeam: boolean;
  token: string;
  menu: any[];
  accessIds: any[];
  teamList: any[];
}

export class OtpVm {
  uid: string;
  otp: number;
  ip: string;
  loginFrom: string;
}


export class IpVm {
  ip: string;
  countryCode: string;
  countryName: string;
  stateCode: string;
  stateName: string;
  city: string;
  postCode: string;
  timeZone: string;
  latitude: string;
  longitude: string;
}

export class AppSocialUser {
  id: string;
  authId: string;
  email: string;
  provider: string;
  firstName: string;
  lastName: string;
  pictureUrl: string;
}

export class YearFile {
  sectionNo: number;
  formName: string;
  ipAddress: string;
  isForTabChange: boolean;
  id: number;
  isCreatedByTros: boolean;
  invoiceId: number;
  isProcessed: boolean;
  year: number;
  statusId: number;
  status: string;
  clientRefund: number;
  invoiceRefund: number;
  amount1: number;
  amount2: number;
  fee: number;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  isAmendment: boolean;
  requestedInvoiceType: string;
  requestedInvoiceTypeId: number;
  tfn: string;
  email: string;
  dob: Date;
  mobile: string;
  firstName: string;
  lastName: string;
  gender: number;
  mobile2: string;
  email2: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postCode: string;
  country: string;
  isPostalAddressSame: boolean;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalPostCode: string;
  postalCountry: string;
  isCitizen: boolean;
  visaTypeId: number;
  visaType: string;
  visaOther: string;
  p1Form: boolean;
  p2Form: boolean;
  p3Form: boolean;
  p4Form: boolean;
  o1Form: boolean;
  o3Form: boolean;
  o6Form: boolean;
  i1OccupationId: number;
  i1OccupationName: string;
  i1OccupationCode: string;
  d1IsYourCarUsedForWorkTravel: boolean;
  d1NoteForWorkCarUsage: string;
  d1NoOfKms: number;
  d1IsCarUnderYourName: boolean;
  d1HasLogBook: boolean;
  d1CarDeduction: number;
  o1HasSpouse: boolean;
  o1SpouseIncome: number;
  o1SpouseFirstName: string;
  o1SpouseLastName: string;
  o1SpouseGivenName: string;
  o1SpouseDob: Date;
  o1SpouseGender: number;
  o2FamilyStatusId: number;
  o2FamilyStatus: string;
  o2InsuaranceId1: number;
  o2Insuarance1: string;
  o2MemebershipNo1: string;
  o2Premium1: number;
  o2RebateReceived1: number;
  o2BenefitCode1: string;
  o2BenefitCodeId1: number;
  o2Gkey: string;
  o2GfileId: number;
  o2InsuaranceId2: number;
  o2Insuarance2: string;
  o2MemebershipNo2: string;
  o2Premium2: number;
  o2RebateReceived2: number;
  o2BenefitCode2: string;
  o2BenefitCodeId2: number;
  o3HasHelp: boolean;
  o3HelpBalance: number;
  o3HasSfss: boolean;
  o3SfssBalance: number;
  o3OtherBalance: number;
  o3HasOtherDebt: boolean;
  o4MaritialStatus: string;
  o4MaritialStatusCode: string;
  o4MaritialStatusId: number;
  o4Vetrans: string;
  o4VetransCode: string;
  o4VetransId: number;
  o5NoOfKids: number;
  o5LevyExDays: number;
  o5LevyEx: string;
  o5LevyExCode: string;
  o5LevyExId: number;
  o6HasHospitalCover: boolean;
  o6M2Days: number;
  o6M2Code: string;
  o7Under18Code: string;
  o7Under18Id: number;
  o7Under18: string;
  o7Under18Amount: number;
  o8OtherInfo: string;
  o8Gkey: string;
  o8GfileId: number;
  f1HasCenterLink: boolean;
  f1CenterLinkPayType: string;
  f1CenterLinkPayTypeId: number;
  f1CenterLinkDebtAmount: number;
  f1HasChildSupport: boolean;
  f1ChildSupportDebtAmount: number;
  f1HasPaymentPlans: boolean;
  f1IsBankrupt: boolean;
  isF2Verified: boolean;
  f2Bsb: string;
  f2Acc: string;
  f2AccHolder: string;
  isF3Verified: boolean;
  f3GfileId: number;
  f3GfileIdTypeId: number;
  f3Gfile
  f3Gkey: string;
  isLicence: boolean; 
  f3LicenceGfileId: number;
  f3LicenceGkey : string;
  f3SfileId: number;
  f3SfileIdTypeId: number;
  f3Skey: string;
  f3S2fileId: number;
  f3S2key: string;
  f1Form: boolean;
  f2Form: boolean;
  f3Form: boolean;
  f4Comments: string;
  isDeleted: boolean;
  deletedById: number;
  deletedBy: string;
  deletedAt: Date;
  deletedReason: string;
  isLodged: boolean;
  errorTypeId: number;
  errorType: string;
  lastUpdatedAt: Date;
  lastUpdatedBy: string;
  lastUpdatedById: number;

}

export class YearFileSection {
  id: number;
  yearFileId: number;
  income: boolean;
  incomeMore: boolean;
  i1Section: boolean;
  i1SectionDone: boolean;
  i2Section: boolean;
  i2SectionDone: boolean;
  i3Section: boolean;
  i3SectionDone: boolean;
  i4Section: boolean;
  i4SectionDone: boolean;
  i5Section: boolean;
  i5SectionDone: boolean;
  i6Section: boolean;
  i6SectionDone: boolean;
  i7Section: boolean;
  i7SectionDone: boolean;
  i8Section: boolean;
  d8SectionDone: boolean;
  isDeductionVisible: boolean;
  deduction: boolean;
  deductionMore: boolean;
  d1Section: boolean;
  d1SectionDone: boolean;
  d2Section: boolean;
  d2SectionDone: boolean;
  d3Section: boolean;
  d3SectionDone: boolean;
  d4Section: boolean;
  d4SectionDone: boolean;
  d5Section: boolean;
  d5SectionDone: boolean;
  d6Section: boolean;
  d6SectionDone: boolean;
  d7Section: boolean;
  d7SectionDone: boolean;
  other: boolean;
  otherMore: boolean;
  o1Section: boolean;
  o1SectionDone: boolean;
  o2Section: boolean;
  o2SectionDone: boolean;
  o3Section: boolean;
  o3SectionDone: boolean;
  o4Section: boolean;
  o4SectionDone: boolean;
  o5Section: boolean;
  o5SectionDone: boolean;
  o6Section: boolean;
  o6SectionDone: boolean;
  o7Section: boolean;
  o7SectionDone: boolean;
  o8Section: boolean;
  o8SectionDone: boolean;
  finish: boolean;
}


export class TopCalc {
  id: number;
  invoiceYearId: number;
  year: number;
  yearFee: number;
  accTimeFee: number;
  businessFee: number;
  rentalFee: number;
  ffrFee: number;
  trosFee: number;
  assessmentFee: number;
  verificationFee: number;
  deductionFee: number;
  cashDepositFee: number;
  amount1: number;
  amount2: number;
  clientRefund: number;
  netRefund: number;
  atoDebt: number;
  feeSubTotal: number;
  feeGst: number;
  feeTotal: number;
  ciTaxableIncome: number;
  ciTaxFreePart: number;
  ciTaxPayable: number;
  ciSubTotal1: number;
  ciOffset: number;
  ciHealthOffset: number;
  ciSenPenBenOffset: number;
  ciSmallBusinessOffset: number;
  ciLowIncomeOffset: number;
  ciLumpSum: number;
  ciOtherOffset: number;
  ciSubTotal2: number;
  ciResult1: number;
  ciMedicareLevy: number;
  ciLevySurcharge: number;
  ciLevySurchargeDesc: number;
  ciSubTotal3: number;
  ciResult2: number;
  ciTaxWithHeld: number;
  ciArrears: number;
  ciForeign: number;
  ciTfnAmount: number;
  ciFranking: number;
  ciOtherRefundable: number;
  ciOtherAmount: number;
  ciPaygTaxInstalment: number;
  cisubTotal4: number;
  ciFinalResult: number;
  ciHecs: number;
}

export class YearFileMaster {
  topCalc: TopCalc;
  yearFile: YearFile;
}

export class YearFileAndSection {
  yFile: YearFile;
  ySection: YearFileSection;
}


export class IdVerifyRequestVm {
  identityId: number;
  type: string;
  typeId: number;
  acquisitionDate: string;
  birthDate: string;
  cardExpiry: string;
  cardNumber: string;
  cardType: string;
  certificateNumber: string;
  countryOfIssue: string;
  customerReferenceNumber: string;
  dateOfEvent: string;
  expiryDate: string;
  familyName: string;
  familyName2: string;
  fullName1: string;
  fullName2: string;
  fullName3: string;
  fullName4: string;
  gender: string;
  givenName: string;
  givenName2: string;
  immiCardNumber: string;
  individualReferenceNumber: string;
  licenceNumber: string;
  middleName: string;
  name: string;
  passportNumber: string;
  registrationDate: string;
  registrationNumber: string;
  registrationState: string;
  registrationYear: string;
  stateOfIssue: string;
  stockNumber: string;
  travelDocumentNumber: string;

  postcode: string;
  suburb: string;
  state: string;
  streetName: string;
  streetType: string;
  streetNumber: string;
  flatUnitNumber: string;
  habitationBuildingName: string;
}

export class ClientIndentity {
  id: number;
  clientId: number;
  isLatest: boolean;
  isPrimary: boolean;
  gfileId: number;
  gkey: string;
  isChecked: boolean;
  verificationCode: string;
  verificationId: string;
  verifiedAt: Date;
  verifiedBy: string;
  verifiedById: number;
  createdAt: Date;
  createdBy: string;
  createdById: number;
  isUploadedByClient: boolean;
  type: string;
  typeId: number;
  secondaryIdType: number;
  isLicence: boolean;
  licenceBackGfileId: number;
  licenceBackGkey: string;
}

export class Client {
  id: number;
  oldClientId: number;
  gdriveFolderId: string;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  createdYear: number;
  flagId: number;
  flag: string;
  flaggedAt: Date;
  flaggedById: number;
  flaggedBy: string;
  tfn: string;
  abn: number;
  dob: Date;
  occupation: string;
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  email2: string;
  mobile: string;
  mobile2: string;
  sourceId: number;
  source: string;
  isCitizen: boolean;
  visaTypeId: number;
  visaType: string;
  visaOther: string;
  noOfKids: number;
  hasSpouse: boolean;
  spouseFirstName: string;
  spouseLastName: string;
  spouseGivenName: string;
  spouseDob: Date;
  spouseGender: number;
  emailSmsMasterId: number;
  portalAccessedAt: Date;
  portalAccessedById: number;
  portalAccessedBy: string;
  landLine: string;
  overSeasContact: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postCode: string;
  country: string;
  isPostalAddressSame: boolean;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalPostCode: string;
  postalCountry: string;
  isCreatedFromBackEnd: boolean;
  p1Form: boolean;
  p2Form: boolean;
  p3Form: boolean;
  p4Form: boolean;
  f2Form: boolean;
  f3Form: boolean;
  idUploadEmailCount: number;
  idUploadEmailSentAt: Date;
  bankDetailId: number;
  primaryId: number;
  secondaryId: number;
  secondaryId2: number;
  f3Uploaded: boolean;
  regId: number;
}

export class Enquiry {
  id: number;
  oldEnquiryId: number;
  referralCode: string;
  statusId: number;
  status: string;
  statusChangedById: number;
  statusChangedBy: string;
  statusChangedAt: Date;
  tfn: string;
  dob: Date;
  firstName: string;
  lastName: string;
  email: string;
  email2: string;
  mobile: string;
  mobile2: string;
  sourceId: number;
  source: string;
  isExistingClient: boolean;
  clientId: number;
  deletedAt: Date;
  deletedById: number;
  deletedBy: string;
  isInvoiceCreated: boolean;
  invoiceId: number;
  reason: string;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  uid: string;
  isPortalAccessed: boolean;
  portalAccessedAt: Date;
  portalAccessedById: number;
  portalAccessedBy: string;
  portalNotAccessedAt: Date;
  portalNotAccessedById: number;
  portalNotAccessedBy: string;
  portalNotAccessedReason: string;
  isConvertedToClient: boolean;
  noOfAttempts: number;
  latestAttemptTime: Date;
  isUserCreated: boolean;
  userId: number;
  isFromAgent: boolean;
  agentId: number;
  agentName: string;
  ip: string;
  gdriveFolderId: string;
  idProofId: number;
  gender: number;
  isCitizen: boolean;
  visaTypeId: number;
  visaType: string;
  visaOther: string;
  noOfKids: number;
  hasSpouse: boolean;
  spouseFirstName: string;
  spouseLastName: string;
  spouseGivenName: string;
  spouseDob: Date;
  spouseGender: number;
  spouseIncome: number;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postCode: string;
  country: string;
  isPostalAddressSame: boolean;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalPostCode: string;
  postalCountry: string;
  p1Form: boolean;
  p2Form: boolean;
  p3Form: boolean;
  p4Form: boolean;
  regId: number;

}

export class HandiTaxVm {
  id: number;
  shortUrlCode: string;
  dob: Date;
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  success: boolean;
}

export class EnquiryVm {
  id: number;
  password: string;
  oldEnquiryId: number;
  referralCode: string;
  statusId: number;
  status: string;
  statusChangedById: number;
  statusChangedBy: string;
  statusChangedAt: Date;
  tfn: string;
  dob: Date;
  firstName: string;
  lastName: string;
  email: string;
  email2: string;
  mobile: string;
  mobile2: string;
  sourceId: number;
  source: string;
  isExistingClient: boolean;
  clientId: number;
  deletedAt: Date;
  deletedById: number;
  deletedBy: string;
  isInvoiceCreated: boolean;
  invoiceId: number;
  reason: string;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  uid: string;
  isPortalAccessed: boolean;
  portalAccessedAt: Date;
  portalAccessedById: number;
  portalAccessedBy: string;
  portalNotAccessedAt: Date;
  portalNotAccessedById: number;
  portalNotAccessedBy: string;
  portalNotAccessedReason: string;
  isConvertedToClient: boolean;
  noOfAttempts: number;
  latestAttemptTime: Date;
  isUserCreated: boolean;
  userId: number;
  isFromAgent: boolean;
  agentId: number;
  agentName: string;
  ip: string;
  gdriveFolderId: string;
  idProofId: number;
  gender: number;
  isCitizen: boolean;
  visaTypeId: number;
  visaType: string;
  visaOther: string;
  noOfKids: number;
  hasSpouse: boolean;
  spouseFirstName: string;
  spouseLastName: string;
  spouseGivenName: string;
  spouseDob: Date;
  spouseGender: number;
  spouseIncome: number;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postCode: string;
  country: string;
  isPostalAddressSame: boolean;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalPostCode: string;
  postalCountry: string;
  p1Form: boolean;
  p2Form: boolean;
  p3Form: boolean;
  p4Form: boolean;
  emailSmsCount: number;
  emailSmsLastSentAt: Date;
  tempDob: string;
  origin: string;
}

export class XType {
  id: number;
  name: string;
  note: string;
  seq: number;
  isVisible: boolean;
  code: string;
  cssClass: string;
}

export class TempUploadVm {
  id: number;
  idx: number;
  size: string;
  ext: string;
  name: string;
  progress: number;
  contentType: string;
  hasError: boolean;
}

export class GfileUploadVm {
  type: string;
  typeId: number;
  enquiryId: number;
  clientId: number;
  invoiceId: number;
  invoiceYearId: number;
  formName: string;
  isReUpload: boolean;
  oldId: number;
  multiId: number;
}


export class AddressTemplate {
  constructor(
    public buildingName: string,
    public numberFirst: number,
    public numberLast: number,
    public flatNumberPrefix: string,
    public flatNumber: number,
    public flatNumberSuffix: string,
    public levelNumber: number,
    public streetName: string,
    public streetType: string,
    public suburb: string,
    public state: string,
    public postCode: string,
    public streetAddress: string,
    public confidence: number
  ) { }

}

export interface IAddressTemplate {
  total: number;
  results: AddressTemplate[];
}


export class UnCheckTypeValue {
  type: string;
  value: boolean;
}


export class UnCheckFormDto {
  yearFileSection: YearFileSection;
  type: string;
  value: boolean;
}

export class FileUploadResult {
  success: boolean;
  id: number;
  key: string;
}

export class Gfile {
  id: number;
  name: string;
  ext: string;
  size: number;
  gkey: string;
  userUid: number;
  clientId: number;
  yearFileId: number;
  inboxId: number;
  type: string;
  typeId: number;
  isTros: boolean;
  formName: string;
  isDeleted: boolean;
  deletedByUid: number;
  deletedBy: string;
  deletedAt: Date;
  createdByUid: number;
  createdBy: string;
  createdAt: Date;
}

export class Multi {
  sectionNo: number;
  formName: string;
  id = 0;
  invoiceYearId = 0;
  isIncome = true;
  typeId = 0;
  type: string;
  gfileId: number;
  gkey: string;
  abn = 0;
  name: string;
  taxWithHeld: number;
  payment: number;
  unTaxedAmount: number;
  payType: string;
  payTypeId: number;
  cdepPayment: number;
  rfba: number;
  resc: number;
  totalAllowances: number;
  lumpA: number;
  lumpB: number;
  lumpD: number;
  lumpE: number;
  typeCode: string;
  frankedAmount: number;
  unFrankedAmount: number;
  frankedCredit: number;
  payDate: Date;
  userId: string;
  isDeathPayment: boolean;
}

export class MultiRent {
  id = 0;
  invoiceYearId = 0;
  gfileId: number;
  gkey: string;
  userId: string;
  propertyPercentage: number;
  streetNameNumber: string;
  suburb: string;
  state: string;
  postCode: string;
  dateOfFirstRentalIncome: Date;
  noOfWeek: number;
  rentalIncome: number;
  otherRentalIncome: number;
  advertiseTenant: number;
  corporateBodyFees: number;
  borrwingExp: number;
  cleaning: number;
  councilRate: number;
  capitalAllownce: number;
  lawnMoving: number;
  insurance: number;
  interestOnLoan: number;
  landTax: number;
  legalFees: number;
  pestControl: number;
  agentFees: number;
  maintenance: number;
  capitalWorkDeduction: number;
  telPostage: number;
  travelExpnse: number;
  waterCharges: number;
  sundryRentalExp: number;
  profitLoss: number;
  totalRent: number;
  totalExp: number;

}


export class PayPal {
  // id: number;
  // invoiceId: number;
  // clientId: number;
  // gstCaseId: number;
  // payerId: string;
  // payerFirstName: string;
  // payerLastName: string;
  // payerPhone: string;
  // amount: string;
  // initId: string;
  // transId: string;
  // email: string;
  // payGuid: string;

  id: number;
invoiceId: number;
gstCaseId: number;
clientId: number;
clientName: string;
email: string;
mobile: string;
description: string;
amount: number;
transRef: string;
isPaid: boolean;
payGuid: string;
createdAt: Date;
createdBy: string;
createdById: number;
cancelledAt: Date;
cancelledBy: string;
cancelledById: number;
cancelledReason: string;
initId: string;
payerId: string;
payerEmail: string;
payerFirstName: string;
payerLastName: string;
payerPhone: string;
transId: string;
paidTime: Date;
invoiceNo: number;
rowId: string;


}

export class Inbox {
  id: number;
  clientId: number;
  subject: string;
  note: string;
  isTros: boolean;
  isRead: boolean;
  readAt: Date;
  readBy: string;
  readByUid: number;
  createdAt: Date;
  createdBy: string;
  createdUid: number;
  hasAttachment: boolean;
  isDone: boolean;
  agentId: number;
  agentName: string;
}

export class Estimate {
  filename: string;
  invoice: Invoice;
  client: Client;
  invoiceYears: InvoiceYear[];
  invoiceCalc: InvoiceCalc;
}

export class GstEstimate {
  gstCase: GstCase;
  client: Client;
  gstForms: GstForm[];
}

export class InvoiceCalc {
  id: number;
  invoiceId: number;
  invoiceTypeId: number;
  hasGroup: boolean;
  accTimeFee: number;
  businessFee: number;
  rentalFee: number;
  ffrFee: number;
  trosFee: number;
  assessmentFee: number;
  verificationFee: number;
  deductionFee: number;
  cashDepositFee: number;
  amount1: number;
  amount2: number;
  estInvoiceRefund: number;
  atoDebt: number;
  netRefund: number;
  actualRefund: number;
  amount1Loss: number;
  feeLoss: number;
  totalLoss: number;
  exAmount1: number;
  exAmount2: number;
  exField1: string;
  exField2: string;
  feeSubTotal: number;
  feeGst: number;
  feeTotal: number;
  recoveredAmount: number;
  discount: number;
}


export class InvoiceYear {
  id: number;
  isCreatedByTros: boolean;
  invoiceId: number;
  isProcessed: boolean;
  year: number;
  gkey: string;
  statusId: number;
  status: string;
  clientRefund: number;
  invoiceRefund: number;
  amount1: number;
  amount2: number;
  fee: number;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  isAmendment: boolean;
  requestedInvoiceType: string;
  requestedInvoiceTypeId: number;
  tfn: string;
  email: string;
  dob: Date;
  mobile: string;
  firstName: string;
  lastName: string;
  gender: number;
  landLine: string;
  overSeasContact: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postCode: string;
  country: string;
  isPostalAddressSame: boolean;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalPostCode: string;
  postalCountry: string;
  isCitizen: boolean;
  visaTypeId: number;
  visaType: string;
  visaOther: string;
  p1Form: boolean;
  p2Form: boolean;
  p3Form: boolean;
  p4Form: boolean;
  o1Form: boolean;
  o3Form: boolean;
  o6Form: boolean;
  i1OccupationId: number;
  i1OccupationName: string;
  i1OccupationCode: string;
  d1IsYourCarUsedForWorkTravel: boolean;
  d1NoteForWorkCarUsage: string;
  d1NoOfKms: number;
  d1IsCarUnderYourName: boolean;
  d1HasLogBook: boolean;
  d1CarDeduction: number;
  o1HasSpouse: boolean;
  o1SpouseIncome: number;
  o1SpouseFirstName: string;
  o1SpouseLastName: string;
  o1SpouseGivenName: string;
  o1SpouseDob: Date;
  o1SpouseGender: number;
  o2FamilyStatusId: number;
  o2FamilyStatus: string;
  o2InsuaranceId1: number;
  o2Insuarance1: string;
  o2MemebershipNo1: string;
  o2Premium1: number;
  o2RebateReceived1: number;
  o2BenefitCode1: string;
  o2BenefitCodeId1: number;
  o2Gkey: string;
  o2GfileId: number;
  o2InsuaranceId2: number;
  o2Insuarance2: string;
  o2MemebershipNo2: string;
  o2Premium2: number;
  o2RebateReceived2: number;
  o2BenefitCode2: string;
  o2BenefitCodeId2: number;
  o3HasHelp: boolean;
  o3HelpBalance: number;
  o3HasSfss: boolean;
  o3SfssBalance: number;
  o3OtherBalance: number;
  o3HasOtherDebt: boolean;
  o4MaritialStatus: string;
  o4MaritialStatusCode: string;
  o4MaritialStatusId: number;
  o4Vetrans: string;
  o4VetransCode: string;
  o4VetransId: number;
  o5NoOfKids: number;
  o5LevyExDays: number;
  o5LevyEx: string;
  o5LevyExCode: string;
  o5LevyExId: number;
  o6HasHospitalCover: boolean;
  o6M2Days: number;
  o6M2Code: string;
  o7Under18Code: string;
  o7Under18Id: number;
  o7Under18: string;
  o7Under18Amount: number;
  o8OtherInfo: string;
  o8Gkey: string;
  o8GfileId: number;
  f1HasCenterLink: boolean;
  f1CenterLinkPayType: string;
  f1CenterLinkPayTypeId: number;
  f1CenterLinkDebtAmount: number;
  f1HasChildSupport: boolean;
  f1ChildSupportDebtAmount: number;
  f1HasPaymentPlans: boolean;
  f1IsBankrupt: boolean;
  isF2Verified: boolean;
  f2AccHolder: string;
  f2Bsb: string;
  f2Acc: string;
  isF3Verified: boolean;
  f3GfileId: number;
  f3Gkey: string;
  f3SfileId: number;
  f3Skey: string;
  f1Form: boolean;
  f2Form: boolean;
  f3Form: boolean;
  f4Comments: string;
  isDeleted: boolean;
  deletedById: number;
  deletedBy: string;
  deletedAt: Date;
  deletedReason: string;
  isLodged: boolean;
  hasError: boolean;
  lastUpdatedAt: Date;
  lastUpdatedBy: string;
  lastUpdatedById: number;

}

export class Invoice {
  id: number;
  uid: string;
  tempUid: string;
  isTemp: boolean;
  enquiryId: number;
  clientId: number;
  year: number;
  isAgent: boolean;
  agentId: number;
  agentName: string;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  statusId: number;
  status: string;
  statusChangedAt: Date;
  statusChangedById: number;
  statusChangedBy: string;
  subStatusId: number;
  subStatus: string;
  subStatusChangedAt: Date;
  subStatusChangedById: number;
  subStatusChangedBy: string;
  isAllocated: boolean;
  allocatedAt: Date;
  teamId: number;
  teamName: string;
  leaderId: number;
  leader: string;
  staffId: number;
  staff: string;
  isStaffAllocated: boolean;
  staffAllocatedAt: Date;
  rejectedReasonId: number;
  rejectedReason: string;
  subId1: number;
  sub1: string;
  subId2: number;
  sub2: string;
  subId3: number;
  sub3: string;
  subId4: number;
  sub4: string;
  subId5: number;
  sub5: string;
  subId6: number;
  sub6: string;
  subId7: number;
  sub7: string;
  subId8: number;
  sub8: string;
  subId9: number;
  sub9: string;
  subId10: number;
  sub10: string;
  step: number;
  isEft: boolean;
  splitId: number;
  invoiceTypeId: number;
  invoiceType: string;
  invoiceDate: Date;
  invoiceNo: number;
  s1IsInterviewSheetDone: boolean;
  s1Occupation: string;
  s1OccupationCode: string;
  s1NoOfKids: number;
  s1AnyWorkRelatedExp: boolean;
  s1D1CarExp: number;
  s1D3ClothExp: number;
  s1D5OtherWorkExp: number;
  s1D9Donations: number;
  s1D10LastYearFee: number;
  s1IsIncomeHigh: boolean;
  s1PartnerName: string;
  s1PartnerDob: Date;
  s1PartnerIncome: number;
  s1InvoiceTypeId: number;
  s1Comment: string;
  s1IsCitizen: boolean;
  s1VisaTypeId: number;
  s1VisaType: string;
  s1VisaOther: string;
  s2AtoPrefill: boolean;
  s2ClientInGovReports: boolean;
  s2LodgementYear: boolean;
  s2InterviewSheetInGovReports: boolean;
  s2HasAtoDebts: boolean;
  s2AtoDebtsAmount: number;
  s2HasHelpLoan: boolean;
  s2HelpLoanAmount: number;
  s3ReSentTimes: number;
  s5Is2AtoIdAttached: boolean;
  s5IsIdVerified: boolean;
  s5IsAllDetailsVerified: boolean;
  s5IsFilePrinted: boolean;
  s5IsPaidFeeReceived: boolean;
  s5PaidFeeReceivedVia: string;
  s5PaidFeeReceivedViaId: number;
  s5PaidFeeReceivedRef: string;
  s5PaidGfileId: number;
  s5PaidGkey: string;
  s5TrosChequeRef: string;
  s5IsTrosChequePaid: boolean;
  s5TrosAmountSplitId: number;
  s5Comment: string;
  s7IsBankDetailsOk1: boolean;
  s7IsBankDetailsOk2: boolean;
  s7IsDetailChangedBack1: boolean;
  s7IsDetailChangedBack2: boolean;
  s7AtoFollowUpDate1: Date;
  s7AtoFollowUpDate2: Date;
  s8IsMoneyRecovered: boolean;
  s8Comment: string;
  s8IsClientFlagged: boolean;
  isClosedAuto: boolean;
  closedAt: Date;
  isApproved: boolean;
  isApprovedByClient: boolean;
  approvedAt: Date;
  approvedBy: string;
  approvedById: number;
  approvedIpAddress: string;
  bankDetailId: number;
  addressId: number;
  primaryId: number;
  primaryId2: number;
  primaryTypeId: number;
  primaryKey: string;
  primaryKey2: string;
  secondaryId: number;
  secondaryTypeId: number;
  secondaryKey: string;
  secondaryId2: number;
  secondaryKey2: string;
  processingYears: string;
  requiredChangeComment: string;
  isAmendment: boolean;
  idVerifyAttemptCount: number;
  idVerifyLastAttemptAt: Date;
  isIdVerified: boolean;
}

export class ErrorModel {
  success: boolean;
  controller: string;
  action: string;
  error: Custlog;
}


export class Custlog {
  id: number;
  isError: boolean;
  timeStamp: Date;
  origin: string;
  customMessage: string;
  request: string;
  message: string;
  stackStrace: string;
  innerException: string;
  application: string;
  controller: string;
  action: string;
}

export class PayPalLink {
  id: number;
  invoiceId: number;
  clientId: number;
  clientName: string;
  email: string;
  mobile: string;
  description: string;
  amount: number;
  transRef: string;
  isPaid: boolean;
  payGuid: string;
  createdAt: Date;
  createdBy: string;
  createdByUid: number;
  cancelledAt: Date;
  cancelledBy: string;
  cancelledByUid: number;
  cancelledReason: string;
}

export class ClientBankDetail {
  id: number;
  clientId: number;
  isLatest: boolean;
  bsb: string;
  acc: string;
  accHolder: string;
  isCreatedByClient: boolean;
  createdAt: Date;
  createdBy: string;
  createdById: number;
  isOverSeasBank: boolean;
  bankCountry: string;
  bankName: string;
  swiftCode: string;
  branchCode: string;
  accNumber: string;
  overSeasAddress: string;
}


export class GstCase {
  id: number;
  clientId: number;
  status: string;
  statusId: number;
  rejectedReason: string;
  rejectedAt : Date;
  rejectedBy: string;
  rejectedById: number;
  sentAt: Date;
  sentBy: string;
  sentById: number;
  isApproved: boolean;
  isApprovedByClient: boolean;
  approvedAt: Date;
  approvedBy: string;
  approvedById: number;
  approvedIpAddress: string;
  amount: number;
  gst: number;
  total: number;
  isPaid: boolean;
  paidAt: Date;
  paidVia: string;
  paidRef: string;
  payPalTransId: number;
  completedAt: Date;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  uid: string;
  primaryId: number;
  primaryKey: string;
  primaryId2: number;
  primaryKey2: string;
  secondaryId: number;
  secondaryKey: string;
  secondaryId2: number;
  secondaryKey2: string;
  primaryTypeId: number;
  secondaryTypeId: number;


}

export class GstForm {
  id: number;
  gstCaseId: number;
  gstYear: string;
  gstYearId: number;
  gstType: string;
  gstTypeId: number;
  gstName: string;
  starting: Date;
  ending: Date;
  createdAt: Date;
  createdById: number;
  createdBy: string;
  updatedAt: Date;
  updatedById: number;
  updatedBy: string;
  abn: string;
  name: string;
  activity: string;
  totalSales: number;
  salaryWages: number;
  exportSales: number;
  amountWithHeld: number;
  otherGstFreeSales: number;
  paygTaxInstallment: number;
  capitalPurchases: number;
  nonCapitalPurchases: number;
  fuelTaxCredit: number;
  adjustment: number;
  gstOnSales: number;
  gstOnPurchases: number;
  paygTaxWithheld: number;
  netAmount: number;

}
